import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-native-builds-android-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './native-builds-android-section.component.html',
  styleUrl: './native-builds-android-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsAndroidSectionComponent {
  protected readonly androidFeatures = [
    {
      icon: '@tui.layers',
      title: 'Build Variants',
      description:
        'Support for debug, release, and custom build variants with different configurations and optimizations.',
    },
    {
      icon: '@tui.package',
      title: 'Build Flavors',
      description:
        'Create multiple app versions from a single codebase with distinct features and branding.',
    },
    {
      icon: '@tui.shield-check',
      title: 'ProGuard Support',
      description:
        'Built-in code shrinking and obfuscation to protect your app and reduce APK size while improving security.',
    },
  ];
}
